import { render } from "./HomeResourcePreview.vue?vue&type=template&id=6d76192c&scoped=true"
import script from "./HomeResourcePreview.vue?vue&type=script&lang=js"
export * from "./HomeResourcePreview.vue?vue&type=script&lang=js"

import "./HomeResourcePreview.vue?vue&type=style&index=0&id=6d76192c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6d76192c"]])

export default __exports__